import React from 'react'
import "./Loader.css"

const Loader = () => {
  return (
<div className="loader-container">
<div className="preloader">
  <div className="preloader__ring">
    <div className="preloader__sector">D</div>
    <div className="preloader__sector">I</div>
    <div className="preloader__sector">N</div>
    <div className="preloader__sector">M</div>
    <div className="preloader__sector">A</div>
    <div className="preloader__sector">'</div>
    <div className="preloader__sector">S</div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector">P</div>
    <div className="preloader__sector">E</div>
    <div className="preloader__sector">R</div>
    <div className="preloader__sector">S</div>
    <div className="preloader__sector">O</div>
    <div className="preloader__sector">N</div>
    <div className="preloader__sector">A</div>
    <div className="preloader__sector">L</div>
    <div className="preloader__sector">.</div>
    <div className="preloader__sector">.</div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
  </div>
  <div className="preloader__ring">
    <div className="preloader__sector">D</div>
    <div className="preloader__sector">I</div>
    <div className="preloader__sector">N</div>
    <div className="preloader__sector">M</div>
    <div className="preloader__sector">A</div>
    <div className="preloader__sector">'</div>
    <div className="preloader__sector">S</div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector">P</div>
    <div className="preloader__sector">O</div>
    <div className="preloader__sector">R</div>
    <div className="preloader__sector">T</div>
    <div className="preloader__sector">F</div>
    <div className="preloader__sector">O</div>
    <div className="preloader__sector">L</div>
    <div className="preloader__sector">I</div>
    <div className="preloader__sector">O</div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
    <div className="preloader__sector"></div>
  </div>
</div>
</div>
  )
}

export default Loader
